// Copyright: IQGeo Limited 2010-2019
import $ from 'jquery';
import _ from 'underscore';
import myw from 'myWorld-base';

/*
 * Populates the login page
 */
const LoginPage = {
    msg: myw.msg.bind(myw, 'login'),

    async init(loginInfo) {
        this.loginInfo = loginInfo;
        this.template = _.template($('#login-page-template').html());
        this.fieldTemplate = _.template($('#login-field-template').html());
        this.fieldsSpec = loginInfo.auth_fields;

        await this.loadMessages();
        this.render();
        this.initValues();
    },

    /*
     * Loads client messages and any necessary module messages
     * @return {promise}
     */
    loadMessages() {
        const messagesPromises = [myw.localisation.ready];

        //check for addtional namespaces in labels of fields
        _.each(this.fieldsSpec, fieldSpec => {
            const parts = fieldSpec.label.split('.');
            let moduleName;

            if (parts.length > 2) {
                //module name is the label excluding last two parts
                moduleName = parts.slice(0, parts.length - 2).join('.');
                messagesPromises.push(myw.localisation.loadModuleLocale(moduleName));
            }
        });

        return Promise.all(messagesPromises);
    },

    render() {
        let html;
        let el;
        const loginInfo = this.loginInfo;

        if (loginInfo.message_id) {
            loginInfo.message = this.msg(loginInfo.message_id, { app_name: loginInfo.redirect_to });
        }

        //sanitizing message since it can include message or message_id from server via url
        loginInfo.message = _.escape(loginInfo.message);

        html = this.template(loginInfo);
        el = $(html);

        el.find('#login-submission')
            .attr('value', this.msg('submission')) //message directly in value attribute wasn't being translated
            .click(this.onSubmit.bind(this));

        this.renderAuthFields(el);

        myw.translate('login', el);

        $('body').html(el);
        // We don't use translate for the footer to give a more professional
        // look whilst loading.
        $('#built-by-footer').html(this.msg('built_by_footer'));

        //focus on first element
        this.fieldsSpec[0].formElem.find('input').focus();
    },

    renderAuthFields(el) {
        const fieldsElem = el.find('#login-fields');

        for (const fieldSpec of this.fieldsSpec) {
            const parts = fieldSpec.label.split('.');
            let labelMessageGroup;
            let labelMessage;

            if (parts.length === 1) {
                labelMessageGroup = 'login';
                labelMessage = fieldSpec.label;
            } else {
                //use last two 'parts'
                labelMessageGroup = parts.slice(-2)[0];
                labelMessage = parts.slice(-2)[1];
            }

            fieldSpec.translatedLabel = myw.msg(labelMessageGroup, labelMessage);
            fieldSpec.formElem = $(this.fieldTemplate(fieldSpec));
            fieldsElem.append(fieldSpec.formElem);
        }
    },

    initValues() {
        //ENH: remove this functionality or make it more generic
        const myworld_user_data =
                this.loginInfo.use_login_cookie && myw.Util.readCookie('myworldapp_user_data'),
            login_data = myworld_user_data && myworld_user_data.split('|'),
            username = login_data && login_data.length > 0 && login_data[0],
            password = login_data && login_data.length > 1 && login_data[1];

        if (username) $('#login-user').val(username);
        if (password) $('#login-pass').val(password);

        //fill in username (ex: from previous failed auth request)
        //ENH: make generic
        if (this.loginInfo.user) $('#login-user').val(this.loginInfo.user);
    },

    onSubmit(e) {
        e.preventDefault();

        const cookify_user_data = this.loginInfo.use_login_cookie,
            cookie_timeout_hours = this.loginInfo.login_cookie_timeout_hours || 0;
        const username = $('#login-user').val();
        const password = $('#login-pass').val();

        if (cookify_user_data) {
            // Get the username and password to keep for later in a cookie.
            if (username && password) {
                // Set the cookie to expire in the configured time.
                myw.Util.writeCookie(
                    'myworldapp_user_data',
                    `${username}|${password}`,
                    cookie_timeout_hours
                );
            }
        }

        //Reset session usage
        const localStoragePath = `myworld/!!!shared!!!/state/${username}`;
        const localStorageJsonString = localStorage.getItem(localStoragePath);

        if (localStorageJsonString) {
            try {
                let sharedStorage = JSON.parse(localStorageJsonString);
                delete sharedStorage.usageMonitor;
                localStorage.setItem(localStoragePath, JSON.stringify(sharedStorage));
            } catch (e) {
                console.log('Error clearing stored usage session', e);
            }
        }
        $('#login').submit();
    }
};

export default LoginPage;
